<template>
  <!-- 动态加载组件 -->
  <component :pulldata="data" :is="isComponent"></component>
</template>
<script>
// 
import { getsubject} from "@/api/course";
import { isMain,getSessionStorage } from '@/utils/tools'
import { newCourse } from '@/utils/course'
import courseContent1 from "@/views/course/course_content/course_content1"
import courseContent2 from "@/views/course/course_content/course_content2"
import courseContent2_2 from "@/views/course/course_content/course_content2_2"

export default {
  data() {
      return {
        cid: null,
        data: {},
        isComponent:''
      }
    },
    components: {
      courseContent1,
      courseContent2,
      courseContent2_2
    },
    methods: {
      pullData() {
        this.$toast.loading({
          mask: true,
          message: "加载中..."
        });
        let querys = this.$route.query;
        this.cid = querys.cid;
        getsubject({
            cid: this.$route.query.cid,
            id: this.$route.query.id
          })
          .then((data) => {
            this.data = data;
            document.title = data.project_name;
            // 判断是哪一个课（bid为1或2）
            if(getSessionStorage('request','/bid') && getSessionStorage('request','/bid')==2){
              // 上线判断
              if(!isMain() || newCourse(this.cid)) {
                this.isComponent = courseContent2_2;
              }else{
                this.isComponent = courseContent2;
              }
            }else{
              this.isComponent = courseContent1;
            }
            this.$toast.clear();
          })
      }
    },
    created() {
      this.pullData();
    },
}
</script>